/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { tenantsUpsert } from "../../funcs/tenantsUpsert.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  tenantId: z.string(),
  body: components.TenantUpsert$inboundSchema.optional(),
};

export const tool$tenantsUpsert: ToolDefinition<typeof args> = {
  name: "tenants-upsert",
  description: `Create or Update Tenant

Idempotently creates or updates a tenant. Required before associating destinations.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantsUpsert(
      client,
      args.tenantId,
      args.body,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
